import { render } from "./UpdateRes.vue?vue&type=template&id=5c142a38"
import script from "./UpdateRes.vue?vue&type=script&lang=js"
export * from "./UpdateRes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__